if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.dataset.loading === 'true') return;
        this.dataset.loading = 'true';

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const documentFragment = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = documentFragment.querySelector('[data-cart-drawer-recommendations-content]');

            if (recommendations) {
              this.innerHTML = recommendations.outerHTML;
            } else {
              this.remove();
            }
          })
          .catch((error) => {
            console.error('Cart drawer recommendations failed:', error);
            this.remove();
          });
      }
    }
  );
}
